import { responseHero } from "../utils/axiosInterceptor";
import { MiningProducedDashboard } from "../models/types/MiningProducedDashboard";

export const getMiningProductionDashboardData = (): Promise<MiningProducedDashboard> => {
    return new Promise<MiningProducedDashboard>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/miningprods`).then((response) => {
            resolve(response.data as MiningProducedDashboard);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};